import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleBrokerDataClientId } from '../../../../stores/algos-list/actions';
import { getIsClientIdShow } from '../../../../stores/algos-list/getters';
import CellToggleHide from './CellToggleHide';

const ClientIdHideButton = () => {
  const dispatch = useDispatch();
  const isClientIdShow = useSelector(getIsClientIdShow);

  const onToggle = () => {
    dispatch(toggleBrokerDataClientId());
  };

  return <CellToggleHide onToggle={onToggle} show={isClientIdShow} />;
};

export default ClientIdHideButton;
